import React, { useEffect } from "react"

import Logo from "./assets/images/logo.svg"

import { Options } from "./components"

export const App = () => {
	return (
		<div className="home">
			<section className="top-section">
				<div className="container">
					<img
						src={Logo}
						className="logo"
						alt="Logo"
					/>

					<div className="text-content">
						<h3>Welcome to the payment selection screen for Pittaway.dev server access.</h3>

						<strong>Please be aware that this is a closed-access service. Any unauthorised subscriptions will be refunded.</strong>

						<p>
							For more information please contact us via email using the link below.
							<a
								className="btn ghost"
								href="mailto:olly@pittaway.dev"
							>
								Email Us
							</a>
						</p>
					</div>
				</div>
			</section>
			<section className="bottom-section">
				<div className="container">
					<div className="options-available">
						<h3>Access To Servers</h3>
						<hr />
						<Options
							plans={{
								Monthly: {
									price: 10,
									quantity: 12,
									description: "Monthly subscription to Pittaway.dev server access.",
									frequency: "month",
									paymentLink: "https://buy.stripe.com/14kfZy0P5c5icTK6oo"
								},
								"Bi-Yearly": {
									price: 55,
									quantity: 2,
									description: "Bi-Yearly subscription to Pittaway.dev server access.",
									frequency: "6 months",
									paymentLink: "https://buy.stripe.com/dR69BacxNfhuaLCcMO"
								},
								Yearly: {
									price: 105,
									quantity: 1,
									description: "Yearly subscription to Pittaway.dev server access.",
									frequency: "year",
									paymentLink: "https://buy.stripe.com/dR66oYfJZfhuaLCdQT"
								}
							}}
						/>
					</div>
					<a
						href="https://billing.stripe.com/p/login/14k01ddYIcrU7jqfYY"
						className="btn manage-button ghost"
					>
						Manage Current Subscription
					</a>
				</div>
			</section>
		</div>
	)
}

export default App
